export const alertMode = {
  alertForCaseCreationAndThenNotifyOnly:
    "alertForCaseCreationAndThenNotifyOnly",
  default: "default",
  notifyOnly: "notifyOnly",
} as const;
